<template>
    <div class="openapi-page">
        <el-card>
            <template #header>
                <div class="page-header"><span>开放订单</span></div>
            </template>
            <el-form :model="search" label-width="90px" class="search-form">
                <el-row :gutter="16">
                    <el-col :span="6"><el-form-item label="订单号"><el-input v-model="search.orderNo" clearable @keyup.enter="searchData" /></el-form-item></el-col>
                    <el-col :span="6"><el-form-item label="业务单号"><el-input v-model="search.requestBizNo" clearable @keyup.enter="searchData" /></el-form-item></el-col>
                    <el-col :span="6"><el-form-item label="AppKey"><el-input v-model="search.appKey" clearable @keyup.enter="searchData" /></el-form-item></el-col>
                    <el-col :span="6"><el-form-item label="商户ID"><el-input v-model="search.merchantId" clearable @keyup.enter="searchData" /></el-form-item></el-col>
                    <el-col :span="6"><el-form-item label="产品编码"><el-input v-model="search.productCode" clearable @keyup.enter="searchData" /></el-form-item></el-col>
                    <el-col :span="6"><el-form-item label="VIN"><el-input v-model="search.vin" clearable @keyup.enter="searchData" /></el-form-item></el-col>
                    <el-col :span="6">
                        <el-form-item label="订单状态">
                            <el-select v-model="search.status" clearable style="width: 100%">
                                <el-option label="处理中" value="PROCESSING" />
                                <el-option label="成功" value="SUCCESS" />
                                <el-option label="失败" value="FAILED" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="扣费状态">
                            <el-select v-model="search.chargeStatus" clearable style="width: 100%">
                                <el-option label="已扣费" value="CHARGED" />
                                <el-option label="已退费" value="REFUNDED" />
                                <el-option label="未扣费" value="NONE" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="创建时间">
                            <el-date-picker v-model="dateRange" type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" value-format="YYYY-MM-DD HH:mm:ss" style="width: 100%" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <div class="search-actions">
                    <el-button type="primary" @click="searchData">查询</el-button>
                    <el-button @click="resetSearch">重置</el-button>
                </div>
            </el-form>
            <el-table :data="tableData" border height="calc(100vh - 385px)" v-loading="state.tableLoading">
                <el-table-column prop="orderNo" label="订单号" min-width="180" show-overflow-tooltip />
                <el-table-column prop="requestBizNo" label="业务单号" min-width="160" />
                <el-table-column prop="appKey" label="AppKey" min-width="200" show-overflow-tooltip />
                <el-table-column prop="merchantId" label="商户ID" min-width="140" />
                <el-table-column prop="productName" label="产品" min-width="150" />
                <el-table-column prop="vin" label="VIN" min-width="180" />
                <el-table-column prop="licensePlate" label="车牌" min-width="100" />
                <el-table-column prop="status" label="状态" width="100">
                    <template #default="scope"><el-tag :type="statusType(scope.row.status)">{{ statusText(scope.row.status) }}</el-tag></template>
                </el-table-column>
                <el-table-column prop="chargeStatus" label="扣费" width="100" />
                <el-table-column label="售价" width="100"><template #default="scope">{{ yuan(scope.row.salePrice) }}</template></el-table-column>
                <el-table-column label="成本" width="100"><template #default="scope">{{ yuan(scope.row.costPrice) }}</template></el-table-column>
                <el-table-column prop="callbackStatus" label="回调" width="100">
                    <template #default="scope"><el-tag :type="callbackType(scope.row.callbackStatus)">{{ callbackText(scope.row.callbackStatus) }}</el-tag></template>
                </el-table-column>
                <el-table-column prop="reportUrl" label="报告地址" min-width="180" show-overflow-tooltip />
                <el-table-column prop="failReason" label="失败原因" min-width="180" show-overflow-tooltip />
                <el-table-column prop="createTime" label="创建时间" min-width="170" />
                <el-table-column fixed="right" label="操作" width="90">
                    <template #default="scope"><el-button size="small" @click="openDetail(scope.row)">详情</el-button></template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination background layout="total, sizes, prev, pager, next" v-model:current-page="pagination.current" v-model:page-size="pagination.size" :total="pagination.total" :page-sizes="pagination.sizes" @current-change="loadData" @size-change="loadData" />
            </div>
        </el-card>

        <el-dialog v-model="detail.visible" title="订单详情" width="980px">
            <el-descriptions :column="2" border>
                <el-descriptions-item label="订单号">{{ detail.row.orderNo || "--" }}</el-descriptions-item>
                <el-descriptions-item label="业务单号">{{ detail.row.requestBizNo || "--" }}</el-descriptions-item>
                <el-descriptions-item label="内部订单ID">{{ detail.row.internalOrderId || "--" }}</el-descriptions-item>
                <el-descriptions-item label="内部记录ID">{{ detail.row.internalRecordId || "--" }}</el-descriptions-item>
                <el-descriptions-item label="下游回调地址" :span="2">{{ detail.row.callbackUrl || "未传回调地址，订单结果直接通过查询接口获取" }}</el-descriptions-item>
                <el-descriptions-item label="报告地址" :span="2">{{ detail.row.reportUrl || "--" }}</el-descriptions-item>
                <el-descriptions-item label="原始结果" :span="2"><pre class="json-box">{{ detail.row.rawResult || "--" }}</pre></el-descriptions-item>
            </el-descriptions>

            <div class="callback-section">
                <div class="section-title">
                    <span>下游回调记录</span>
                    <el-button size="small" @click="loadCallbackRecords" :loading="state.callbackLoading">刷新</el-button>
                </div>
                <el-table :data="callbackRecords" border max-height="320" v-loading="state.callbackLoading" empty-text="该订单暂无下游回调记录">
                    <el-table-column prop="callbackUrl" label="回调地址" min-width="220" show-overflow-tooltip />
                    <el-table-column prop="httpStatus" label="HTTP状态" width="100" />
                    <el-table-column label="结果" width="90">
                        <template #default="scope"><el-tag :type="scope.row.success ? 'success' : 'danger'">{{ scope.row.success ? '成功' : '失败' }}</el-tag></template>
                    </el-table-column>
                    <el-table-column prop="errorMessage" label="失败原因" min-width="180" show-overflow-tooltip />
                    <el-table-column prop="createTime" label="回调时间" min-width="170" />
                    <el-table-column label="操作" width="90">
                        <template #default="scope"><el-button size="small" link type="primary" @click="openCallbackDetail(scope.row)">查看</el-button></template>
                    </el-table-column>
                </el-table>
            </div>
        </el-dialog>

        <el-dialog v-model="callbackDetail.visible" title="回调详情" width="860px">
            <el-descriptions :column="2" border>
                <el-descriptions-item label="开放订单号">{{ callbackDetail.row.openApiOrderNo || "--" }}</el-descriptions-item>
                <el-descriptions-item label="AppKey">{{ callbackDetail.row.appKey || "--" }}</el-descriptions-item>
                <el-descriptions-item label="商户ID">{{ callbackDetail.row.merchantId || "--" }}</el-descriptions-item>
                <el-descriptions-item label="HTTP状态">{{ callbackDetail.row.httpStatus || "--" }}</el-descriptions-item>
                <el-descriptions-item label="回调地址" :span="2">{{ callbackDetail.row.callbackUrl || "--" }}</el-descriptions-item>
                <el-descriptions-item label="请求内容" :span="2"><pre class="json-box">{{ formatJson(callbackDetail.row.requestBody) }}</pre></el-descriptions-item>
                <el-descriptions-item label="响应内容" :span="2"><pre class="json-box">{{ formatJson(callbackDetail.row.responseBody) }}</pre></el-descriptions-item>
                <el-descriptions-item label="失败原因" :span="2">{{ callbackDetail.row.errorMessage || "--" }}</el-descriptions-item>
            </el-descriptions>
        </el-dialog>
    </div>
</template>

<script setup>
import { reactive, ref, onMounted } from "vue";
import { getOpenApiCallbackRecordPage, getOpenApiOrderPage } from "@/api/openapi";

const emptySearch = () => ({ orderNo: "", requestBizNo: "", appKey: "", merchantId: "", productCode: "", vin: "", status: "", chargeStatus: "" });
const search = reactive(emptySearch());
const dateRange = ref([]);
const state = reactive({ tableLoading: false, callbackLoading: false });
const tableData = ref([]);
const callbackRecords = ref([]);
const pagination = reactive({ current: 1, size: 20, total: 0, sizes: [20, 50, 100] });
const detail = reactive({ visible: false, row: {} });
const callbackDetail = reactive({ visible: false, row: {} });

const yuan = (cent) => cent === null || cent === undefined ? "-" : "¥" + (cent / 100).toFixed(2);
const statusText = (status) => ({ SUCCESS: "成功", FAILED: "失败", PROCESSING: "处理中" }[status] || status || "-");
const statusType = (status) => ({ SUCCESS: "success", FAILED: "danger", PROCESSING: "warning" }[status] || "info");
const callbackText = (status) => ({ SUCCESS: "成功", FAILED: "失败", NONE: "无回调" }[status] || status || "无回调");
const callbackType = (status) => ({ SUCCESS: "success", FAILED: "danger", NONE: "info" }[status] || "info");

function params() {
    return { ...search, current: pagination.current, size: pagination.size, startTime: dateRange.value?.[0], endTime: dateRange.value?.[1] };
}

function loadData() {
    state.tableLoading = true;
    getOpenApiOrderPage(params()).then((res) => {
        tableData.value = res.data.records || [];
        pagination.total = res.data.total || 0;
    }).finally(() => state.tableLoading = false);
}

function searchData() {
    pagination.current = 1;
    loadData();
}

function resetSearch() {
    Object.assign(search, emptySearch());
    dateRange.value = [];
    searchData();
}

function openDetail(row) {
    detail.row = row;
    detail.visible = true;
    callbackRecords.value = [];
    loadCallbackRecords();
}

function loadCallbackRecords() {
    if (!detail.row.orderNo) {
        callbackRecords.value = [];
        return;
    }
    state.callbackLoading = true;
    getOpenApiCallbackRecordPage({ openApiOrderNo: detail.row.orderNo, current: 1, size: 20 }).then((res) => {
        callbackRecords.value = res.data.records || [];
    }).finally(() => state.callbackLoading = false);
}

function openCallbackDetail(row) {
    callbackDetail.row = row;
    callbackDetail.visible = true;
}

function formatJson(value) {
    if (!value) return "--";
    try {
        return JSON.stringify(JSON.parse(value), null, 2);
    } catch (e) {
        return value;
    }
}

onMounted(loadData);
</script>

<style lang="scss" scoped>
.openapi-page { padding: 16px; }
.page-header { font-weight: 600; }
.search-form { margin-bottom: 12px; }
.search-actions { text-align: right; }
.pagination-box { margin-top: 14px; display: flex; justify-content: flex-end; }
.callback-section { margin-top: 18px; }
.section-title { display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px; font-weight: 600; }
.json-box { white-space: pre-wrap; word-break: break-all; max-height: 260px; overflow: auto; margin: 0; }
</style>
